import { findContainmentConflicts } from '../../../signal-form-rules/within-span.rule';
import { findOrderConflicts, SpanConflict } from '../../../signal-form-rules/chronologically-ordered.rule';
import { TimesheetFormModel } from './timesheet-form-model';

/**
 * Every way a timesheet's times disagree with one another: an entry that runs backwards, an entry
 * that reaches into its neighbour, and an entry that falls outside the working day the markers
 * bracket.
 *
 * The same two searches the form's schema rules run, asked of a plain model rather than of a form.
 * That is what lets the page decide whether an edit may be *written* on exactly the grounds the
 * form uses to mark it — one comparison, two callers, no second implementation to drift.
 *
 * Coverage is deliberately not among these. An open gap is the normal state of a timesheet being
 * filled in, so it must never stand in the way of an edit; it only stands in the way of a submit.
 *
 * @param model the timesheet as the form holds it
 * @returns one conflict per offending instant, empty when the times are consistent
 */
export function timesheetOrderConflicts(model: TimesheetFormModel): SpanConflict[] {
    return [
        ...findOrderConflicts(model.entries),
        ...findContainmentConflicts({ start: model.startOfWork, end: model.endOfWork }, model.entries),
    ];
}
